const {
  WEB_VITALS,
  RESOURCE_TIMING,
  PAGE_RENDER,
  A11Y,
  AVAILABILITY,
  CDN_HEALTH,
} = require('../../constants/initiatives');
const {
  AVAILABILITY_BROWSER_ERRORS,
  AVAILABILITY_TRANSFER_SIZE,
  AVAILABILITY_FAILURE,
  X_CDN,
  DURATION_SUM,
  RESOURCE_SIZE,
  RESOURCE_FAILURE,
  RESOURCE_SUCCESS,
  HYDRATE_COMPLETE,
  HYDRATE_DURATION,
} = require('../../constants/metrics');

const webVitals = require('../builder/web-vitals');
const resourceTiming = require('../builder/resource-timing');
const pageRender = require('../builder/page-render');
const a11y = require('../builder/a11y');
const availability = require('../builder/availability');
const cdnHealth = require('../builder/cdn-health');
const {
  recordSpan,
  recordHistogram,
  recordCount,
  recordLog,
} = require('../web-monitoring');

const noopFn = () => {};

const initiativesEnabled = {
  [WEB_VITALS]: {
    builder: webVitals,
    sender: (collection) => {
      Object.keys(collection).forEach((key) => {
        recordHistogram(`${WEB_VITALS}.${key}`, collection[key]);
      });
    },
  },
  [RESOURCE_TIMING]: {
    builder: resourceTiming,
    sender: ({ resources }) => {
      (resources || []).forEach((resource) => {
        recordSpan(RESOURCE_TIMING, [], resource);
      });
    },
  },
  [PAGE_RENDER]: {
    builder: pageRender,
    sender: (collection) => {
      recordHistogram(`${PAGE_RENDER}.${HYDRATE_COMPLETE}`, collection[HYDRATE_COMPLETE], 'ms');
      recordHistogram(`${PAGE_RENDER}.${HYDRATE_DURATION}`, collection[HYDRATE_DURATION], 'ms');
    },
  },
  [A11Y]: {
    builder: a11y,
    sender: noopFn,
  },
  [AVAILABILITY]: {
    builder: availability,
    sender: (collection) => {
      (collection[AVAILABILITY_TRANSFER_SIZE] || []).forEach((transferSize) => {
        recordSpan(`${AVAILABILITY}.${AVAILABILITY_TRANSFER_SIZE}`, [], transferSize);
        recordCount(`${AVAILABILITY}.${AVAILABILITY_TRANSFER_SIZE}.${transferSize.initiator}`);
      });

      (collection[AVAILABILITY_FAILURE] || []).forEach((failure) => {
        recordSpan(`${AVAILABILITY}.${AVAILABILITY_FAILURE}`, [], failure);
        recordCount(`${AVAILABILITY}.${AVAILABILITY_FAILURE}.${failure.initiator}`);
      });

      (collection[AVAILABILITY_BROWSER_ERRORS] || []).forEach((errors) => {
        recordLog(errors.message, { filename: errors.filename, initiator: errors.initiator });
        recordCount(`${AVAILABILITY}.${AVAILABILITY_BROWSER_ERRORS}`);
      });
    },
  },
  [CDN_HEALTH]: {
    builder: cdnHealth,
    sender: (collection) => {
      recordHistogram(`${CDN_HEALTH}.${collection[X_CDN]}.${DURATION_SUM}`, collection[DURATION_SUM], 'ms');
      recordHistogram(`${CDN_HEALTH}.${collection[X_CDN]}.${RESOURCE_SIZE}`, collection[RESOURCE_SIZE], 'ms');

      if (collection[RESOURCE_FAILURE]) {
        recordHistogram(`${CDN_HEALTH}.${collection[X_CDN]}.${RESOURCE_FAILURE}`, collection[RESOURCE_FAILURE]);
      }

      if (collection[RESOURCE_SUCCESS]) {
        recordHistogram(`${CDN_HEALTH}.${collection[X_CDN]}.${RESOURCE_SUCCESS}`, collection[RESOURCE_SUCCESS]);
      }
    },
  },
};

const getInitiative = (initiative) => {
  if (initiative.id in initiativesEnabled) {
    return initiativesEnabled[initiative.id];
  }

  throw new Error('Initiative not found');
};

const sendWebMonitoring = (initiative, settings, data) => {
  const { builder, sender } = getInitiative(initiative);
  const { data: payload } = builder(settings, data);

  sender(payload);
};

module.exports = { sendWebMonitoring };
